export default "__VITE_ASSET__2ej7bgQ$__"